import React, { forwardRef } from 'react'
import Number from './Number'
import { fieldContainerProps, fieldProps, inputProps, badgeProps, analyticsProps } from './commonProps'

/** Field for money value inputs */
const Money = forwardRef(({
  id,
  error,
  warning,
  touched,
  focus,
  placeholder,
  name,
  label,
  initialValue,
  className,
  inputRef,
  inputProps,
  disabled,
  autoComplete,
  sensitive,
  maxLength,
  leftBadge,
  rightBadge,
  analytics,
  autoFocus,
  autoFocusDelay,
  maxAllowedValue,
  hideCheckIcon,
  appearance
}, ref) =>
  <Number
    id={id}
    error={error}
    warning={warning}
    touched={touched}
    focus={focus}
    placeholder={placeholder}
    name={name}
    label={label}
    initialValue={initialValue}
    className={className}
    inputRef={inputRef}
    inputProps={inputProps}
    disabled={disabled}
    autoComplete={autoComplete}
    sensitive={sensitive}
    maxLength={maxLength}
    leftBadge={leftBadge === 'default-icon' ? appearance === 'default' ? 'icon-money-dollar' : null : leftBadge}
    rightBadge={rightBadge}
    ref={ref}
    prefix="$"
    decimalScale={0}
    allowNegative={false}
    fixedDecimalScale={false}
    analytics={analytics}
    autoFocus={autoFocus}
    autoFocusDelay={autoFocusDelay}
    maxAllowedValue={maxAllowedValue}
    hideCheckIcon={hideCheckIcon}
    appearance={appearance}
  />
)

Money.propTypes = {
  ...fieldContainerProps,
  ...fieldProps,
  ...inputProps,
  ...badgeProps,
  ...analyticsProps
}

Money.defaultProps = {
  error: null,
  warning: null,
  touched: null,
  placeholder: null,
  label: null,
  initialValue: '',
  maxLength: 9,
  focus: null,
  inputRef: null,
  inputProps: {},
  disabled: false,
  autoComplete: true,
  sensitive: false,
  leftBadge: 'default-icon',
  rightBadge: null,
  autoFocus: false,
  autoFocusDelay: 500,
  maxAllowedValue: null,
  hideCheckIcon: false,
  appearance: 'default'
}

export default Money
